export default class AutoCompleteClient {
  constructor(
    private endpoint: string,
    private language: string,
  ) {}

  public GetItems = (term: string): Promise<string[]> => {
    return fetch(
      `${this.endpoint}?language=${this.language}&term=${term}`,
    ).then((response) => {
      if (!response.ok) throw new Error("Error from search API");
      return response.json();
    });
  };
}
